import { WorkingCenterModelType } from '@teinor/erp/types/company/workingCenter'
import { WorkingCenterCounterModelType } from '@teinor/erp/types/company/workingCenter/workingCenterCounter'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderBoolean, EditRowNotLink } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import ModalCECounterWorkingCenter from './ModalCECounterWorkingCenter'

interface CountersWorkingCenterProps extends ComponentWithPermissions {
    basicData: WorkingCenterModelType
}

const CountersWorkingCenter: React.FC<CountersWorkingCenterProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('counters', 'Contadores'),
        newText: t('createSerie', 'Crear Serie'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableCountersWorkingCenter} CreateModalComponent={ModalCECounterWorkingCenter} EditModalComponent={ModalCECounterWorkingCenter} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ WorkingCenterId: basicData.id }} />
    )
}

interface WorkingCenterCounterModelExtended extends WorkingCenterCounterModelType {
    text: string
}

interface TableCountersWorkingCenterProps extends TableComponentBaseScreenInnerProps { }


const TableCountersWorkingCenter: React.FC<TableCountersWorkingCenterProps> = ({ setOpened, setTableInstance, userPermissions, extraWhereParams }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<WorkingCenterCounterModelExtended> = [
        {
            id: 'serie',
            dataKey: 'serie',
            label: t('serie', 'Serie'),
            width: 140,
        },
        {
            id: 'prefix',
            dataKey: 'prefix',
            label: t('prefix', 'Prefijo'),
            width: 140,
        },
        {
            id: 'buy_order',
            dataKey: 'buy_order',
            label: t('buyOrderS', 'Ped. compra'),
            simpleLabel: t('buyOrder', 'Pedido de compra'),
            toolTip: t('buyOrder', 'Pedido de compra'),
            hideColumnByDefault: true
        },
        {
            id: 'buy_deliverynote',
            dataKey: 'buy_deliverynote',
            label: t('buyDeliveryNoteS', 'Al. compra'),
            simpleLabel: t('buyDeliveryNote', 'Albarán de compra'),
            toolTip: t('buyDeliveryNote', 'Albarán de compra'),
            hideColumnByDefault: true,
            minWidth: 120
        },
        {
            id: 'buy_invoice',
            dataKey: 'buy_invoice',
            label: t('buyInvoiceS', 'Fact. compra'),
            simpleLabel: t('buyInvoice', 'Factura de compra'),
            toolTip: t('buyInvoice', 'Factura de compra'),
            hideColumnByDefault: true,
            minWidth: 130
        },
        {
            id: 'refund_buy_deliverynote',
            dataKey: 'refund_buy_deliverynote',
            label: t('refundBuyDeliveryNoteS', 'Dev. Al. compra'),
            simpleLabel: t('refundBuyDeliveryNote', 'Devolución albarán de compra'),
            toolTip: t('refundBuyDeliveryNote', 'Devolución albarán de compra'),
            hideColumnByDefault: true,
            minWidth: 150
        },
        {
            id: 'refund_buy_invoice',
            dataKey: 'refund_buy_invoice',
            label: t('refundBuyInvoiceS', 'Dev. Fact. compra'),
            simpleLabel: t('refundBuyInvoice', 'Devolución factura de compra'),
            toolTip: t('refundBuyInvoice', 'Devolución factura de compra'),
            hideColumnByDefault: true,
            minWidth: 160
        },
        {
            id: 'other_expenses',
            dataKey: 'other_expenses',
            label: t('otherExpenses', 'Otros gastos'),
            hideColumnByDefault: true
        },
        {
            id: 'sell_order',
            dataKey: 'sell_order',
            label: t('sellOrder', 'Pedido de venta'),
            hideColumnByDefault: true
        },
        {
            id: 'sell_deliverynote',
            dataKey: 'sell_deliverynote',
            label: t('sellDeliveryNoteS', 'Al. venta'),
            simpleLabel: t('sellDeliveryNote', 'Albarán de venta'),
            toolTip: t('sellDeliveryNote', 'Albarán de venta'),
            hideColumnByDefault: true
        },
        {
            id: 'sell_invoice',
            dataKey: 'sell_invoice',
            label: t('sellInvoiceS', 'Fact. venta'),
            simpleLabel: t('sellInvoice', 'Factura de venta'),
            toolTip: t('sellInvoice', 'Factura de venta'),
            hideColumnByDefault: true,
            minWidth: 120
        },
        {
            id: 'refund_sell_deliverynote',
            dataKey: 'refund_sell_deliverynote',
            label: t('refundSellDeliveryNoteS', 'Dev. Al. venta'),
            simpleLabel: t('refundSellDeliveryNote', 'Devolución Albarán de venta'),
            toolTip: t('refundSellDeliveryNote', 'Devolución Albarán de venta'),
            hideColumnByDefault: true,
            minWidth: 130
        },
        {
            id: 'refund_sell_invoice',
            dataKey: 'refund_sell_invoice',
            label: t('refundSellInvoiceS', 'Dev. Fact. venta'),
            simpleLabel: t('refundSellInvoice', 'Devolución Factura de venta'),
            toolTip: t('refundSellInvoice', 'Devolución Factura de venta'),
            hideColumnByDefault: true,
            minWidth: 140
        },
        {
            id: 'quote_order',
            dataKey: 'quote_order',
            label: t('quoteOrder', 'Presupuestos'),
            hideColumnByDefault: true
        },
        {
            id: 'vat_supported',
            dataKey: 'vat_supported',
            label: t('vatSupported', 'IVA Soportado'),
            hideColumnByDefault: true,
            minWidth: 130
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            width: 45,
        },
        {
            id: 'edit',
            dataKey: 'serie',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        }
    ]
    return (
        <TwinTable columns={columns} name='countersWorkingCenter' getDataFrom='/api/app/workingCenter/workingCenterCounter/getAllWorkingCenterCounters'
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })} setTableInstance={setTableInstance} extraWhereParams={extraWhereParams} />
    )
}

export default CountersWorkingCenter